module.exports = __webpack_public_path__ + "img/9.9ab17c8c.jpg";